module.exports = __webpack_public_path__ + "img/kh.1c24c2a8.svg";